
export const storeOrderLog = async (orderID, currentUser, description, notes) => {

    //ENV VARIABLE
    const apiUrl = process.env.REACT_APP_API_URL;
    
    //WRITE LOG ENDPOINT
    let endpoint = "writeOrderLog";


    //
    let rawBody = {
        "orderID": orderID,
        "description": description,
        "notes": notes,
        "user": currentUser
    };

    
    //
    const requestBody = JSON.stringify(rawBody);
    

    //
    let response = await fetch(apiUrl + endpoint,
    {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: requestBody
    });

    let responseContent = await response.json();


} //END METHOD

